import { render } from "./required-vote.vue?vue&type=template&id=08f11fc0"
import script from "./required-vote.vue?vue&type=script&lang=js"
export * from "./required-vote.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__